export default __webpack_public_path__ + "static/media/fast-delivery.53a05eff.png";